import { FlexColumn } from '@interco/inter-ui/components/Flex'
import { Signal } from '@interco/inter-ui/components/Signal'
import { Text } from '@interco/inter-ui/components/Text'
import { Button } from '@interco/inter-ui/components/Button'
import { Spacing } from '@interco/inter-ui/components/Spacing'
import { interWbNavigate } from '@interco/inter-webview-bridge'
import Canceled from '@interco/icons/build-v4/orangeds/MD/canceled'

import { ErrorPageProps } from './types'

export const ErrorPage = ({
  title,
  description,
  primaryButton,
  secondaryButton,
  refetch,
}: ErrorPageProps) => {
  const handleRetryButton = () => refetch()

  const handleBackButton = () => interWbNavigate.requestGoBack()

  return (
    <FlexColumn height="100vh">
      <FlexColumn alignItems="center" justifyContent="center" height="100%">
        <Signal icon={Canceled} theme="error" intensity="bold" />
        <Spacing mb="sm" />
        <Text variant="headline-h1" as="h1" semiBold>
          {title}
        </Text>
        <Spacing mb="xxs" />
        <Text variant="body-3" as="p" style={{ textAlign: 'center' }}>
          {description}
        </Text>
      </FlexColumn>
      <FlexColumn className="p-6" gap="1rem">
        <Button fullWidth onClick={handleRetryButton}>
          {primaryButton}
        </Button>
        <Button variant="secondary" fullWidth onClick={handleBackButton}>
          {secondaryButton}
        </Button>
      </FlexColumn>
    </FlexColumn>
  )
}
